/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsEventSubTypesEnum = 'MIGRATION_FAILED' | 'MIGRATION_DONE' | 'MIGRATION_STARTED' | 'REQUEST_DENIED' | 'REQUEST_APPROVED' | 'REQUEST_STARTED' | 'FAILED_EXITING_MAINTENANCE_MODE' | 'EXITED_MAINTENANCE_MODE' | 'EXITING_MAINTENANCE_MODE' | 'FAILED_ENTERING_MAINTENANCE_MODE' | 'ENTERED_MAINTENANCE_MODE' | 'ENTERING_MAINTENANCE_MODE' | 'MAINTENANCE_SCHEDULED' | 'MAINTENANCE_CONFIRMED' | 'MAINTENANCE_STARTED' | 'MAINTENANCE_COMPLETED' | 'MAINTENANCE_CANCELLED' | 'RELEASE_FAILED' | 'RELEASE_DONE' | 'RELEASE_STARTED' | 'ADDITION_FAILED' | 'ADDITION_DONE' | 'ADDITION_STARTED' | 'DEACTIVATION_FAILED' | 'DEACTIVATION_DONE' | 'DEACTIVATION_STARTED' | 'ACTIVATION_FAILED' | 'ACTIVATION_DONE' | 'ACTIVATION_STARTED' | 'IMPORT_FAILED' | 'IMPORT_DONE' | 'IMPORT_STARTED' | 'CANCELLATION_FAILED' | 'CANCELLATION_DONE' | 'CANCELLATION_STARTED' | 'CREATION_OD_FAILED' | 'CREATION_OD_DONE' | 'CREATION_OD_STARTED' | 'CREATION_FAILED' | 'CREATION_DONE' | 'CREATION_STARTED' | 'UPDATE_FAILED' | 'UPDATE_DONE' | 'UPDATE_STARTED' | 'DELETION_FAILED' | 'DELETION_DONE' | 'DELETION_STARTED' | 'IMPLICIT_CREATION_FAILED' | 'IMPLICIT_CREATION_DONE' | 'IMPLICIT_CREATION_STARTED' | 'UPGRADE_FAILED' | 'UPGRADE_DONE' | 'UPGRADE_STARTED' | 'UPDATE_PROPERTIES_STARTED' | 'UPDATE_PROPERTIES_DONE' | 'UPDATE_PROPERTIES_FAILED' | 'COPY_CREDENTIALS_STARTED' | 'COPY_CREDENTIALS_DONE' | 'COPY_CREDENTIALS_FAILED' | 'ROTATE_CREDENTIALS_STARTED' | 'ROTATE_CREDENTIALS_DONE' | 'ROTATE_CREDENTIALS_FAILED' | 'DELETE_CREDENTIALS_STARTED' | 'DELETE_CREDENTIALS_DONE' | 'DELETE_CREDENTIALS_FAILED' | 'CREATE_DATASTORE_STARTED' | 'CREATE_DATASTORE_DONE' | 'CREATE_DATASTORE_FAILED' | 'CREATE_CDVX_STARTED' | 'CREATE_CDVX_DONE' | 'CREATE_CDVX_FAILED' | 'DELETE_DATASTORE_STARTED' | 'DELETE_DATASTORE_DONE' | 'DELETE_DATASTORE_FAILED' | 'PAIRING_AUTHORIZATION_STARTED' | 'PAIRING_AUTHORIZATION_DONE' | 'PAIRING_AUTHORIZATION_FAILED' | 'REGISTER_BILLING_DONE' | 'REGISTER_BILLING_FAILED' | 'UNREGISTER_BILLING_DONE' | 'UNREGISTER_BILLING_FAILED' | 'AGENT_RECONFIGURE_JOB_CREATED' | 'CHANGE_SELLER' | 'RECONFIGURE_OAUTH_APP' | 'DELETE_OAUTH_APP_STARTED' | 'DELETE_OAUTH_APP_DONE' | 'DELETE_OAUTH_APP_FAILED' | 'VMC_POOL_LINK_STARTED' | 'VMC_POOL_LINK_VALIDATION_DONE' | 'VMC_POOL_LINK_PENDING_APPROVAL' | 'VMC_POOL_LINK_ASSIGNED' | 'VMC_POOL_LINK_VMC_ORG_RENAME_DONE' | 'VMC_POOL_LINK_CSP_VMC_OAUTH_CREATION_DONE' | 'VMC_POOL_LINK_CSP_VMC_USER_MANAGEMENT_DONE' | 'VMC_POOL_LINK_IRR_RECONFIGURE_DONE' | 'VMC_POOL_LINK_DONE' | 'VMC_POOL_LINK_FAILED' | 'VMC_POOL_UNLINK_STARTED' | 'VMC_POOL_UNLINK_VALIDATION_DONE' | 'VMC_POOL_UNLINK_ORG_UNASSIGNMENT_STARTED' | 'VMC_POOL_UNLINK_IRR_RECONFIGURE_DONE' | 'VMC_POOL_UNLINK_CSP_UNLINK_DONE' | 'VMC_POOL_UNLINK_DONE' | 'VMC_POOL_UNLINK_VMC_UNLINK_DONE' | 'VMC_POOL_UNLINK_FAILED' | 'APPLICATION_STARTED' | 'CONFIGS_UPDATED' | 'GLOBAL_ORG_CAPABILITY_UPDATED' | 'ORG_TYPE_ORG_CAPABILITY_UPDATED' | 'RECONFIGURE_IRR_STARTED' | 'RECONFIGURE_IRR_DONE' | 'RECONFIGURE_IRR_FAILED' | 'STREAMLINE_IRR_CONFIG_STARTED' | 'STREAMLINE_IRR_CONFIG_DONE' | 'STREAMLINE_IRR_CONFIG_FAILED' | 'ASSIGN_GCVE_STARTED' | 'ASSIGN_VMCA_STARTED' | 'ASSIGN_EVS_STARTED' | 'ASSIGN_GCVE_COMPLETED' | 'ASSIGN_VMCA_COMPLETED' | 'ASSIGN_EVS_COMPLETED' | 'ASSIGN_GCVE_FAILED' | 'ASSIGN_VMCA_FAILED' | 'ASSIGN_EVS_FAILED' | 'UNASSIGN_GCVE_STARTED' | 'UNASSIGN_VMCA_STARTED' | 'UNASSIGN_EVS_STARTED' | 'UNASSIGN_GCVE_COMPLETED' | 'UNASSIGN_VMCA_COMPLETED' | 'UNASSIGN_EVS_COMPLETED' | 'UNASSIGN_GCVE_FAILED' | 'UNASSIGN_VMCA_FAILED' | 'UNASSIGN_EVS_FAILED' | 'CREATED' | 'DELETED' | 'PAUSED' | 'RESUMED' | 'UPGRADED' | 'OAUTH_APP_SECRET_ROTATION_STARTED' | 'OAUTH_APP_SECRET_ROTATION_COMPLETED' | 'OAUTH_APP_SECRET_ROTATION_FAILED' | 'IRR_GW_CERT_PROBE_STARTED' | 'IRR_GW_CERT_PROBE_COMPLETED' | 'IRR_GW_CERT_PROBE_FAILED' | 'IRR_GW_CERT_UPDATE_STARTED' | 'IRR_GW_CERT_UPDATE_COMPLETED' | 'IRR_GW_CERT_UPDATE_FAILED' | 'EDR_ORG_PROVISION_STARTED' | 'EDR_ORG_PROVISION_COMPLETED' | 'EDR_ORG_PROVISION_FAILED' | 'EDR_ORG_DEPROVISION_STARTED' | 'EDR_ORG_DEPROVISION_COMPLETED' | 'EDR_ORG_DEPROVISION_FAILED' | 'EDR_ORG_CREATE_API_KEY_STARTED' | 'EDR_ORG_CREATE_API_KEY_COMPLETED' | 'EDR_ORG_CREATE_API_KEY_FAILED' | 'EDR_ORG_DELETE_API_KEY_STARTED' | 'EDR_ORG_DELETE_API_KEY_COMPLETED' | 'EDR_ORG_DELETE_API_KEY_FAILED';

export const VcdsEventSubTypesEnum = {

    MIGRATION_FAILED: 'MIGRATION_FAILED' as VcdsEventSubTypesEnum,

    MIGRATION_DONE: 'MIGRATION_DONE' as VcdsEventSubTypesEnum,

    MIGRATION_STARTED: 'MIGRATION_STARTED' as VcdsEventSubTypesEnum,

    REQUEST_DENIED: 'REQUEST_DENIED' as VcdsEventSubTypesEnum,

    REQUEST_APPROVED: 'REQUEST_APPROVED' as VcdsEventSubTypesEnum,

    REQUEST_STARTED: 'REQUEST_STARTED' as VcdsEventSubTypesEnum,

    FAILED_EXITING_MAINTENANCE_MODE: 'FAILED_EXITING_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    EXITED_MAINTENANCE_MODE: 'EXITED_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    EXITING_MAINTENANCE_MODE: 'EXITING_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    FAILED_ENTERING_MAINTENANCE_MODE: 'FAILED_ENTERING_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    ENTERED_MAINTENANCE_MODE: 'ENTERED_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    ENTERING_MAINTENANCE_MODE: 'ENTERING_MAINTENANCE_MODE' as VcdsEventSubTypesEnum,

    MAINTENANCE_SCHEDULED: 'MAINTENANCE_SCHEDULED' as VcdsEventSubTypesEnum,

    MAINTENANCE_CONFIRMED: 'MAINTENANCE_CONFIRMED' as VcdsEventSubTypesEnum,

    MAINTENANCE_STARTED: 'MAINTENANCE_STARTED' as VcdsEventSubTypesEnum,

    MAINTENANCE_COMPLETED: 'MAINTENANCE_COMPLETED' as VcdsEventSubTypesEnum,

    MAINTENANCE_CANCELLED: 'MAINTENANCE_CANCELLED' as VcdsEventSubTypesEnum,

    RELEASE_FAILED: 'RELEASE_FAILED' as VcdsEventSubTypesEnum,

    RELEASE_DONE: 'RELEASE_DONE' as VcdsEventSubTypesEnum,

    RELEASE_STARTED: 'RELEASE_STARTED' as VcdsEventSubTypesEnum,

    ADDITION_FAILED: 'ADDITION_FAILED' as VcdsEventSubTypesEnum,

    ADDITION_DONE: 'ADDITION_DONE' as VcdsEventSubTypesEnum,

    ADDITION_STARTED: 'ADDITION_STARTED' as VcdsEventSubTypesEnum,

    DEACTIVATION_FAILED: 'DEACTIVATION_FAILED' as VcdsEventSubTypesEnum,

    DEACTIVATION_DONE: 'DEACTIVATION_DONE' as VcdsEventSubTypesEnum,

    DEACTIVATION_STARTED: 'DEACTIVATION_STARTED' as VcdsEventSubTypesEnum,

    ACTIVATION_FAILED: 'ACTIVATION_FAILED' as VcdsEventSubTypesEnum,

    ACTIVATION_DONE: 'ACTIVATION_DONE' as VcdsEventSubTypesEnum,

    ACTIVATION_STARTED: 'ACTIVATION_STARTED' as VcdsEventSubTypesEnum,

    IMPORT_FAILED: 'IMPORT_FAILED' as VcdsEventSubTypesEnum,

    IMPORT_DONE: 'IMPORT_DONE' as VcdsEventSubTypesEnum,

    IMPORT_STARTED: 'IMPORT_STARTED' as VcdsEventSubTypesEnum,

    CANCELLATION_FAILED: 'CANCELLATION_FAILED' as VcdsEventSubTypesEnum,

    CANCELLATION_DONE: 'CANCELLATION_DONE' as VcdsEventSubTypesEnum,

    CANCELLATION_STARTED: 'CANCELLATION_STARTED' as VcdsEventSubTypesEnum,

    CREATION_OD_FAILED: 'CREATION_OD_FAILED' as VcdsEventSubTypesEnum,

    CREATION_OD_DONE: 'CREATION_OD_DONE' as VcdsEventSubTypesEnum,

    CREATION_OD_STARTED: 'CREATION_OD_STARTED' as VcdsEventSubTypesEnum,

    CREATION_FAILED: 'CREATION_FAILED' as VcdsEventSubTypesEnum,

    CREATION_DONE: 'CREATION_DONE' as VcdsEventSubTypesEnum,

    CREATION_STARTED: 'CREATION_STARTED' as VcdsEventSubTypesEnum,

    UPDATE_FAILED: 'UPDATE_FAILED' as VcdsEventSubTypesEnum,

    UPDATE_DONE: 'UPDATE_DONE' as VcdsEventSubTypesEnum,

    UPDATE_STARTED: 'UPDATE_STARTED' as VcdsEventSubTypesEnum,

    DELETION_FAILED: 'DELETION_FAILED' as VcdsEventSubTypesEnum,

    DELETION_DONE: 'DELETION_DONE' as VcdsEventSubTypesEnum,

    DELETION_STARTED: 'DELETION_STARTED' as VcdsEventSubTypesEnum,

    IMPLICIT_CREATION_FAILED: 'IMPLICIT_CREATION_FAILED' as VcdsEventSubTypesEnum,

    IMPLICIT_CREATION_DONE: 'IMPLICIT_CREATION_DONE' as VcdsEventSubTypesEnum,

    IMPLICIT_CREATION_STARTED: 'IMPLICIT_CREATION_STARTED' as VcdsEventSubTypesEnum,

    UPGRADE_FAILED: 'UPGRADE_FAILED' as VcdsEventSubTypesEnum,

    UPGRADE_DONE: 'UPGRADE_DONE' as VcdsEventSubTypesEnum,

    UPGRADE_STARTED: 'UPGRADE_STARTED' as VcdsEventSubTypesEnum,

    UPDATE_PROPERTIES_STARTED: 'UPDATE_PROPERTIES_STARTED' as VcdsEventSubTypesEnum,

    UPDATE_PROPERTIES_DONE: 'UPDATE_PROPERTIES_DONE' as VcdsEventSubTypesEnum,

    UPDATE_PROPERTIES_FAILED: 'UPDATE_PROPERTIES_FAILED' as VcdsEventSubTypesEnum,

    COPY_CREDENTIALS_STARTED: 'COPY_CREDENTIALS_STARTED' as VcdsEventSubTypesEnum,

    COPY_CREDENTIALS_DONE: 'COPY_CREDENTIALS_DONE' as VcdsEventSubTypesEnum,

    COPY_CREDENTIALS_FAILED: 'COPY_CREDENTIALS_FAILED' as VcdsEventSubTypesEnum,

    ROTATE_CREDENTIALS_STARTED: 'ROTATE_CREDENTIALS_STARTED' as VcdsEventSubTypesEnum,

    ROTATE_CREDENTIALS_DONE: 'ROTATE_CREDENTIALS_DONE' as VcdsEventSubTypesEnum,

    ROTATE_CREDENTIALS_FAILED: 'ROTATE_CREDENTIALS_FAILED' as VcdsEventSubTypesEnum,

    DELETE_CREDENTIALS_STARTED: 'DELETE_CREDENTIALS_STARTED' as VcdsEventSubTypesEnum,

    DELETE_CREDENTIALS_DONE: 'DELETE_CREDENTIALS_DONE' as VcdsEventSubTypesEnum,

    DELETE_CREDENTIALS_FAILED: 'DELETE_CREDENTIALS_FAILED' as VcdsEventSubTypesEnum,

    CREATE_DATASTORE_STARTED: 'CREATE_DATASTORE_STARTED' as VcdsEventSubTypesEnum,

    CREATE_DATASTORE_DONE: 'CREATE_DATASTORE_DONE' as VcdsEventSubTypesEnum,

    CREATE_DATASTORE_FAILED: 'CREATE_DATASTORE_FAILED' as VcdsEventSubTypesEnum,

    CREATE_CDVX_STARTED: 'CREATE_CDVX_STARTED' as VcdsEventSubTypesEnum,

    CREATE_CDVX_DONE: 'CREATE_CDVX_DONE' as VcdsEventSubTypesEnum,

    CREATE_CDVX_FAILED: 'CREATE_CDVX_FAILED' as VcdsEventSubTypesEnum,

    DELETE_DATASTORE_STARTED: 'DELETE_DATASTORE_STARTED' as VcdsEventSubTypesEnum,

    DELETE_DATASTORE_DONE: 'DELETE_DATASTORE_DONE' as VcdsEventSubTypesEnum,

    DELETE_DATASTORE_FAILED: 'DELETE_DATASTORE_FAILED' as VcdsEventSubTypesEnum,

    PAIRING_AUTHORIZATION_STARTED: 'PAIRING_AUTHORIZATION_STARTED' as VcdsEventSubTypesEnum,

    PAIRING_AUTHORIZATION_DONE: 'PAIRING_AUTHORIZATION_DONE' as VcdsEventSubTypesEnum,

    PAIRING_AUTHORIZATION_FAILED: 'PAIRING_AUTHORIZATION_FAILED' as VcdsEventSubTypesEnum,

    REGISTER_BILLING_DONE: 'REGISTER_BILLING_DONE' as VcdsEventSubTypesEnum,

    REGISTER_BILLING_FAILED: 'REGISTER_BILLING_FAILED' as VcdsEventSubTypesEnum,

    UNREGISTER_BILLING_DONE: 'UNREGISTER_BILLING_DONE' as VcdsEventSubTypesEnum,

    UNREGISTER_BILLING_FAILED: 'UNREGISTER_BILLING_FAILED' as VcdsEventSubTypesEnum,

    AGENT_RECONFIGURE_JOB_CREATED: 'AGENT_RECONFIGURE_JOB_CREATED' as VcdsEventSubTypesEnum,

    CHANGE_SELLER: 'CHANGE_SELLER' as VcdsEventSubTypesEnum,

    RECONFIGURE_OAUTH_APP: 'RECONFIGURE_OAUTH_APP' as VcdsEventSubTypesEnum,

    DELETE_OAUTH_APP_STARTED: 'DELETE_OAUTH_APP_STARTED' as VcdsEventSubTypesEnum,

    DELETE_OAUTH_APP_DONE: 'DELETE_OAUTH_APP_DONE' as VcdsEventSubTypesEnum,

    DELETE_OAUTH_APP_FAILED: 'DELETE_OAUTH_APP_FAILED' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_STARTED: 'VMC_POOL_LINK_STARTED' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_VALIDATION_DONE: 'VMC_POOL_LINK_VALIDATION_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_PENDING_APPROVAL: 'VMC_POOL_LINK_PENDING_APPROVAL' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_ASSIGNED: 'VMC_POOL_LINK_ASSIGNED' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_VMC_ORG_RENAME_DONE: 'VMC_POOL_LINK_VMC_ORG_RENAME_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_CSP_VMC_OAUTH_CREATION_DONE: 'VMC_POOL_LINK_CSP_VMC_OAUTH_CREATION_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_CSP_VMC_USER_MANAGEMENT_DONE: 'VMC_POOL_LINK_CSP_VMC_USER_MANAGEMENT_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_IRR_RECONFIGURE_DONE: 'VMC_POOL_LINK_IRR_RECONFIGURE_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_DONE: 'VMC_POOL_LINK_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_LINK_FAILED: 'VMC_POOL_LINK_FAILED' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_STARTED: 'VMC_POOL_UNLINK_STARTED' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_VALIDATION_DONE: 'VMC_POOL_UNLINK_VALIDATION_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_ORG_UNASSIGNMENT_STARTED: 'VMC_POOL_UNLINK_ORG_UNASSIGNMENT_STARTED' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_IRR_RECONFIGURE_DONE: 'VMC_POOL_UNLINK_IRR_RECONFIGURE_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_CSP_UNLINK_DONE: 'VMC_POOL_UNLINK_CSP_UNLINK_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_DONE: 'VMC_POOL_UNLINK_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_VMC_UNLINK_DONE: 'VMC_POOL_UNLINK_VMC_UNLINK_DONE' as VcdsEventSubTypesEnum,

    VMC_POOL_UNLINK_FAILED: 'VMC_POOL_UNLINK_FAILED' as VcdsEventSubTypesEnum,

    APPLICATION_STARTED: 'APPLICATION_STARTED' as VcdsEventSubTypesEnum,

    CONFIGS_UPDATED: 'CONFIGS_UPDATED' as VcdsEventSubTypesEnum,

    GLOBAL_ORG_CAPABILITY_UPDATED: 'GLOBAL_ORG_CAPABILITY_UPDATED' as VcdsEventSubTypesEnum,

    ORG_TYPE_ORG_CAPABILITY_UPDATED: 'ORG_TYPE_ORG_CAPABILITY_UPDATED' as VcdsEventSubTypesEnum,

    RECONFIGURE_IRR_STARTED: 'RECONFIGURE_IRR_STARTED' as VcdsEventSubTypesEnum,

    RECONFIGURE_IRR_DONE: 'RECONFIGURE_IRR_DONE' as VcdsEventSubTypesEnum,

    RECONFIGURE_IRR_FAILED: 'RECONFIGURE_IRR_FAILED' as VcdsEventSubTypesEnum,

    STREAMLINE_IRR_CONFIG_STARTED: 'STREAMLINE_IRR_CONFIG_STARTED' as VcdsEventSubTypesEnum,

    STREAMLINE_IRR_CONFIG_DONE: 'STREAMLINE_IRR_CONFIG_DONE' as VcdsEventSubTypesEnum,

    STREAMLINE_IRR_CONFIG_FAILED: 'STREAMLINE_IRR_CONFIG_FAILED' as VcdsEventSubTypesEnum,

    ASSIGN_GCVE_STARTED: 'ASSIGN_GCVE_STARTED' as VcdsEventSubTypesEnum,

    ASSIGN_VMCA_STARTED: 'ASSIGN_VMCA_STARTED' as VcdsEventSubTypesEnum,

    ASSIGN_EVS_STARTED: 'ASSIGN_EVS_STARTED' as VcdsEventSubTypesEnum,

    ASSIGN_GCVE_COMPLETED: 'ASSIGN_GCVE_COMPLETED' as VcdsEventSubTypesEnum,

    ASSIGN_VMCA_COMPLETED: 'ASSIGN_VMCA_COMPLETED' as VcdsEventSubTypesEnum,

    ASSIGN_EVS_COMPLETED: 'ASSIGN_EVS_COMPLETED' as VcdsEventSubTypesEnum,

    ASSIGN_GCVE_FAILED: 'ASSIGN_GCVE_FAILED' as VcdsEventSubTypesEnum,

    ASSIGN_VMCA_FAILED: 'ASSIGN_VMCA_FAILED' as VcdsEventSubTypesEnum,

    ASSIGN_EVS_FAILED: 'ASSIGN_EVS_FAILED' as VcdsEventSubTypesEnum,

    UNASSIGN_GCVE_STARTED: 'UNASSIGN_GCVE_STARTED' as VcdsEventSubTypesEnum,

    UNASSIGN_VMCA_STARTED: 'UNASSIGN_VMCA_STARTED' as VcdsEventSubTypesEnum,

    UNASSIGN_EVS_STARTED: 'UNASSIGN_EVS_STARTED' as VcdsEventSubTypesEnum,

    UNASSIGN_GCVE_COMPLETED: 'UNASSIGN_GCVE_COMPLETED' as VcdsEventSubTypesEnum,

    UNASSIGN_VMCA_COMPLETED: 'UNASSIGN_VMCA_COMPLETED' as VcdsEventSubTypesEnum,

    UNASSIGN_EVS_COMPLETED: 'UNASSIGN_EVS_COMPLETED' as VcdsEventSubTypesEnum,

    UNASSIGN_GCVE_FAILED: 'UNASSIGN_GCVE_FAILED' as VcdsEventSubTypesEnum,

    UNASSIGN_VMCA_FAILED: 'UNASSIGN_VMCA_FAILED' as VcdsEventSubTypesEnum,

    UNASSIGN_EVS_FAILED: 'UNASSIGN_EVS_FAILED' as VcdsEventSubTypesEnum,

    CREATED: 'CREATED' as VcdsEventSubTypesEnum,

    DELETED: 'DELETED' as VcdsEventSubTypesEnum,

    PAUSED: 'PAUSED' as VcdsEventSubTypesEnum,

    RESUMED: 'RESUMED' as VcdsEventSubTypesEnum,

    UPGRADED: 'UPGRADED' as VcdsEventSubTypesEnum,

    OAUTH_APP_SECRET_ROTATION_STARTED: 'OAUTH_APP_SECRET_ROTATION_STARTED' as VcdsEventSubTypesEnum,

    OAUTH_APP_SECRET_ROTATION_COMPLETED: 'OAUTH_APP_SECRET_ROTATION_COMPLETED' as VcdsEventSubTypesEnum,

    OAUTH_APP_SECRET_ROTATION_FAILED: 'OAUTH_APP_SECRET_ROTATION_FAILED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_PROBE_STARTED: 'IRR_GW_CERT_PROBE_STARTED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_PROBE_COMPLETED: 'IRR_GW_CERT_PROBE_COMPLETED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_PROBE_FAILED: 'IRR_GW_CERT_PROBE_FAILED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_UPDATE_STARTED: 'IRR_GW_CERT_UPDATE_STARTED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_UPDATE_COMPLETED: 'IRR_GW_CERT_UPDATE_COMPLETED' as VcdsEventSubTypesEnum,

    IRR_GW_CERT_UPDATE_FAILED: 'IRR_GW_CERT_UPDATE_FAILED' as VcdsEventSubTypesEnum,

    EDR_ORG_PROVISION_STARTED: 'EDR_ORG_PROVISION_STARTED' as VcdsEventSubTypesEnum,

    EDR_ORG_PROVISION_COMPLETED: 'EDR_ORG_PROVISION_COMPLETED' as VcdsEventSubTypesEnum,

    EDR_ORG_PROVISION_FAILED: 'EDR_ORG_PROVISION_FAILED' as VcdsEventSubTypesEnum,

    EDR_ORG_DEPROVISION_STARTED: 'EDR_ORG_DEPROVISION_STARTED' as VcdsEventSubTypesEnum,

    EDR_ORG_DEPROVISION_COMPLETED: 'EDR_ORG_DEPROVISION_COMPLETED' as VcdsEventSubTypesEnum,

    EDR_ORG_DEPROVISION_FAILED: 'EDR_ORG_DEPROVISION_FAILED' as VcdsEventSubTypesEnum,

    EDR_ORG_CREATE_API_KEY_STARTED: 'EDR_ORG_CREATE_API_KEY_STARTED' as VcdsEventSubTypesEnum,

    EDR_ORG_CREATE_API_KEY_COMPLETED: 'EDR_ORG_CREATE_API_KEY_COMPLETED' as VcdsEventSubTypesEnum,

    EDR_ORG_CREATE_API_KEY_FAILED: 'EDR_ORG_CREATE_API_KEY_FAILED' as VcdsEventSubTypesEnum,

    EDR_ORG_DELETE_API_KEY_STARTED: 'EDR_ORG_DELETE_API_KEY_STARTED' as VcdsEventSubTypesEnum,

    EDR_ORG_DELETE_API_KEY_COMPLETED: 'EDR_ORG_DELETE_API_KEY_COMPLETED' as VcdsEventSubTypesEnum,

    EDR_ORG_DELETE_API_KEY_FAILED: 'EDR_ORG_DELETE_API_KEY_FAILED' as VcdsEventSubTypesEnum
};

